import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
const differences = [{
  not: 'No es una app ni un curso tradicional',
  is: 'Es un sistema que vive en ti, no en una plataforma'
}, {
  not: 'No necesitas experiencia financiera previa',
  is: 'Funciona desde cero, con cualquier nivel de ingreso'
}, {
  not: 'No depende de motivación temporal',
  is: 'Se basa en hábitos y sistemas que funcionan solos'
}, {
  not: 'No separa mente, emoción y dinero',
  is: 'Trabaja los tres niveles al mismo tiempo'
}, {
  not: 'No te pide que seas otro',
  is: 'Te ayuda a ser la mejor versión financiera de quien ya eres'
}];
export function DifferenceSection() {
  return <section className="py-12 md:py-16 px-4 md:px-8 bg-navy-800" data-id="element-24">
      <div className="max-w-5xl mx-auto" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-26">
          <h3 className="text-3xl md:text-5xl font-bold" data-id="element-27">
            Por Qué Este Método Es Diferente
          </h3>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20" data-id="element-28">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-900 rounded-2xl p-8 border border-red-900/30" data-id="element-29">
            <h4 className="text-xl font-bold text-red-400 mb-6 flex items-center gap-2 border-b border-gray-800 pb-4" data-id="element-30">
              <XCircleIcon className="w-6 h-6" data-id="element-31" /> Lo Que No Es
            </h4>
            <ul className="space-y-6" data-id="element-32">
              {differences.map((diff, i) => <li key={i} className="text-gray-400 flex items-start gap-3" data-id="element-33">
                  <span className="text-red-500 mt-1" data-id="element-34">❌</span> {diff.not}
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-700 rounded-2xl p-8 border border-gold/30 box-glow" data-id="element-35">
            <h4 className="text-xl font-bold text-gold mb-6 flex items-center gap-2 border-b border-gray-600 pb-4" data-id="element-36">
              <CheckCircleIcon className="w-6 h-6" data-id="element-37" /> Lo Que Sí Es
            </h4>
            <ul className="space-y-6" data-id="element-38">
              {differences.map((diff, i) => <li key={i} className="text-white font-medium flex items-start gap-3" data-id="element-39">
                  <span className="text-green-500 mt-1" data-id="element-40">✅</span> {diff.is}
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto mb-16" data-id="element-41">
          <div className="bg-navy-900 border-l-4 border-gold p-8 md:p-10 rounded-r-2xl relative" data-id="element-42">
            <h4 className="text-sm font-bold tracking-widest uppercase text-gold mb-6" data-id="element-43">
              💬 La Historia Detrás Del Sistema:
            </h4>
            <blockquote className="text-lg md:text-xl text-gray-300 italic space-y-4 font-serif" data-id="element-44">
              <p data-id="element-45">
                "Durante años sentí que el dinero no era para mí. Que ganar
                mucho me haría diferente, arrogante, distinto a mi familia.
                Hasta que descubrí que ese pensamiento no era mío. Era un
                programa instalado.
              </p>
              <p data-id="element-46">
                Cuando lo desinstalé, todo cambió. No de golpe. Pero cambió.
              </p>
              <p data-id="element-47">
                Hoy comparto ese sistema contigo. El mismo que transformó mi
                vida financiera y espiritual."
              </p>
            </blockquote>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto" data-id="element-48">
          <blockquote className="text-xl md:text-2xl text-gold font-serif italic mb-4" data-id="element-49">
            "Amado, yo deseo que tú seas prosperado en todas las cosas, y que
            tengas salud, así como prospera tu alma."
          </blockquote>
          <p className="text-gray-400 font-bold" data-id="element-50">— 3 Juan 1:2</p>
        </motion.div>
      </div>
    </section>;
}